module.exports = __webpack_public_path__ + "static/assets/696775a88332c76b6da89d2748d15df7.svg";